import React from 'react';
function PaddingTop({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path d="M21 3H3" strokeLinecap="round" />
      <path
        d="M8.00002 10C8.00002 8.89543 8.89545 8 10 8H14C15.1046 8 16 8.89543 16 10V14C16 15.1046 15.1046 16 14 16H10C8.89545 16 8.00002 15.1046 8.00002 14V10Z"
        strokeLinecap="round"
      />
    </svg>
  );
}

export default PaddingTop;
